export default __webpack_public_path__ + "static/Verde36-b35e5ba52715ff7b8347b1f61f209453.pdf";